export default __webpack_public_path__ + "static/media/Hand_right.c4456539.svg";